import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import {apiBaseUrl} from './Config';

class AdminUploadUsersModal extends React.Component {
    constructor(props) {
	super(props);

	this.state = {
	    file: "",
	    users: [],
	    disabled: true
	};

	this.resource = apiBaseUrl + "adminUsersActions";

	this.handleChange = this.handleChange.bind(this);
	this.handlePreview = this.handlePreview.bind(this);
	this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
	// Only do this when one of the fields changes
	if (this.state.file !== prevState.file)
	{
	    // All fields except 'year' have to be filled in to enable submit button
	    if (this.state.file !== "")
	    {
		this.setState({disabled: false});
	    } else {
		this.setState({disabled: true});
	    }
	}
    }
    
    handleChange(event) {
	if (event.target.files) {
	    this.setState({[event.target.name]: event.target.files[0]});
	} else {
	    this.setState({[event.target.name]: event.target.value});
	}
    }

    handlePreview(event) {
	const reader = new FileReader();

	reader.addEventListener('load', (event) => {
	    var data = [];
	    var content = event.target.result;
	    var lines = content.split("\r\n"); // Probably doesn't work on all platforms ...

	    lines.forEach((line) => {
		var user = line.split(";");
		
		data.push({
		    firstname: user[0],
		    lastname: user[1],
		    year: user[2],
		    troop: user[3],
		    email: user[4]
		});
	    });

	    this.setState({users: data});
	});
	
	reader.readAsText(this.state.file, "iso-8859-1");
	
	event.preventDefault();
    }

    handleSubmit(event) {
	fetch(this.resource, {
	    method: "POST",
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Content-Type": "application/json"
	    },
	    body: JSON.stringify(this.state.users)
	})
	    .then((response) => {
		if (response.status === 401) {
		    this.setState({users: []});
		    this.props.onAuthError();
		}
		
		if (!response.ok) {
		    throw new Error("Kunde inte skapa");
		}
		
		return response.json();
	    })
	    .then((result) => {
		this.setState({users: []});
		this.props.onSuccess();
	    })
	    .catch((error) => {
		this.setState({users: []});
		this.props.onError();
	    });
	
	event.preventDefault();
    }
    
    render() {
	const users = this.state.users;
	var i = 0;
	
	return (
	    <Modal show={this.props.show} onHide={this.props.onHide}>
		<Modal.Header closeButton>
		    <Modal.Title>Ladda upp anv&auml;ndare</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		    <Form.Group>
			<Form.Text>
			    Ladda upp en semikolonseparerad fil med formatet:
			    <br /><br/>
			    f&ouml;rnamn;efternamn;kurs&aring;r;scoutk&aring;r;email
			</Form.Text>
		    </Form.Group>
		    <br />
		    <Form>
			<Form.Group controlId="formFile">
			    <Form.Label>CSV-fil</Form.Label>
			    <Form.Control name="file" type="file" onChange={this.handleChange} />
			</Form.Group>
		    </Form>
		    <br />
		    {users.length !==0 &&
		     <Form.Group>
			 <Form.Text>
			     <table>
				 <thead>
				     <tr>
					 <th>F&ouml;rnamn</th>
					 <th>Efternamn</th>
					 <th>Kurs&aring;r</th>
					 <th>Scoutk&aring;r</th>
					 <th>Email</th>
				     </tr>
				 </thead>
				 <tbody>
				     {users.map(user => (
					 <tr key={i++}>
					     <td>{user.firstname}</td>
					     <td>{user.lastname}</td>
					     <td>{user.year}</td>
					     <td>{user.troop}</td>
					     <td>{user.email}</td>
					 </tr>
				     ))}
				 </tbody>
			     </table>
			 </Form.Text>
		     </Form.Group>
		    }
		</Modal.Body>
		<Modal.Footer>
		    <Button variant="alumni" onClick={this.props.onHide}>Avbryt</Button>
		    {this.state.disabled?
		     <Button variant="alumni" disabled>F&ouml;rhandsgranska</Button>
		     :
		     <div>
			 {users.length ===0?
			  <Button variant="alumni" onClick={this.handlePreview}>F&ouml;rhandsgranska</Button>
			  :
			  <Button variant="alumni" onClick={this.handleSubmit}>Ladda upp</Button>
			 }
		     </div>
		    }
		</Modal.Footer>
	    </Modal>
	);
    }
}

export default AdminUploadUsersModal;
